<div style="font-family: roboto; background-color: #ff9800 ;color: black; font-size: 14px;transform: skewX(-29.5deg); width: 250px; display: flex; flex-direction: row; ">
        <div style="transform: skewX(29.5deg); margin-left: 10px;">{{ this.DividerText }}</div>        
</div>